import {
  BedIcon,
  LockersIcon,
  HamburgerIcon,
  ListBulletsIcon,
  ListChecksIcon,
  SwapIcon,
  SwatchesIcon,
} from "@phosphor-icons/react";

const iconProps = { size: 16, fill: "currentColor" };
export const boardIcons: Record<string, React.JSX.Element> = {
  RO: <BedIcon {...iconProps} />,
  SC: <HamburgerIcon {...iconProps} />,
  BB: <SwapIcon {...iconProps} />,
  HB: <ListBulletsIcon {...iconProps} />,
  FB: <ListChecksIcon {...iconProps} />,
  AI: <SwatchesIcon {...iconProps} />,
  RD: <LockersIcon {...iconProps} />,
};
